import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["textContent"]

import { computed } from 'vue';
import { Mutations } from '@/store';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { TypeLabel } from '@/models/hardware.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'HardwareComponentItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const router = useRouter();

const componentTypes = computed<TypeLabel[]>(
  () => store.state.hardwareConfiguration?.componentTypes || [],
);

const type = computed(() => {
  return (
    componentTypes.value.find((i) => i.value === props.item.type)?.label ||
    `(${props.item.type})`
  );
});

const showHardware = () => {
  store.commit(Mutations.SetViewItem, props.item);
  router.push('/hardware/' + props.item.url);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "big-list-item",
    onClick: showHardware
  }, [
    _createElementVNode("span", {
      class: _normalizeClass('icon icon-' + __props.item.store),
      title: __props.item.store
    }, null, 10, _hoisted_1),
    _createElementVNode("h2", null, _toDisplayString(__props.item.fullName), 1),
    _createElementVNode("p", {
      class: "big-list-item__subtext",
      textContent: _toDisplayString(_unref(type))
    }, null, 8, _hoisted_2)
  ]))
}
}

})